import { ApiService, toData } from '~/shared/api'
import { LruCache } from '~/shared/cache'
import type { ApiDataResponse } from '~/shared/types/api'
import type { RegionLocation } from '~/types/regions'

type RegionsResponse = ApiDataResponse<RegionLocation[]>

const REGIONS_CACHE_LIFETIME_SECONDS = 300

export class RegionsService extends ApiService {
  private readonly cache = new LruCache<RegionLocation[]>({
    lifetimeSeconds: REGIONS_CACHE_LIFETIME_SECONDS,
  })

  readonly urls = {
    regions: '/api/v1/yavagro/vacancies/regions',
  }

  async getRegions(): Promise<RegionLocation[]> {
    const cached = this.cache.get('regions')
    if (cached) {
      return cached
    }

    const regions = await this.http
      .request<RegionsResponse>({ url: this.urls.regions })
      .then(toData())
    this.cache.set('regions', regions)
    return regions
  }

  getSearchRegions(value: string): Promise<RegionLocation[]> {
    return this.http
      .request<RegionsResponse>({ url: this.urls.regions, params: { q: value } })
      .then(toData())
  }
}
